export const WHATSAPP_NUMBER = "5511946252220"
export const WHATSAPP_DISPLAY = "(11) 94625-2220"
export const EMAIL = "kjrdesenvolvimento@gmail.com"
export const LINKEDIN = "https://www.linkedin.com/company/kjr-desenvolvimento"

export const whatsappLink = (message) =>
  `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}${message ? `&text=${encodeURIComponent(message)}` : ""}`

export const services = [
  {
    id: "sites",
    title: "Sites",
    kicker: "Landing Pages & Institucionais",
    description:
      "Landing Pages e Sites Institucionais modernos, responsivos e otimizados para conversão — a vitrine digital que sua empresa merece.",
    image: "/images/imagem3.jpg",
    startingAt: "R$ 459,90",
    deliveryTime: "7–15 dias",
    features: ["Landing Page", "Site Institucional", "Design Responsivo"],
    serviceTypes: [
      {
        name: "Landing Page",
        description:
          "Ideal para quem quer apresentar um produto, serviço ou evento de forma direta e objetiva, com foco em conversão.",
        price: "R$ 459,90",
        priceNote: "Sem mensalidade — apenas custo de desenvolvimento e hospedagem",
        features: [
          "Design moderno, 100% responsivo",
          "Integração com formulários, WhatsApp ou redes sociais",
          "Rápida implementação e custo acessível",
        ],
      },
      {
        name: "Site Institucional",
        description:
          "Perfeito para empresas que querem presença digital com várias páginas, como: quem somos, serviços, contato, portfólio.",
        price: "R$ 699,90",
        priceNote: "Com manutenção opcional: R$ 99,99/mês (para atualizações e suporte técnico)",
        features: [
          "Estrutura completa e personalizável",
          "Layout profissional e responsivo",
          "Integração com Google Maps, WhatsApp, formulários",
        ],
      },
    ],
    technologies: ["Java", "Spring Boot", "React", "Next.js", "Tailwind CSS", "Responsive Design"],
  },
  {
    id: "ecommerce",
    title: "E-commerce",
    kicker: "Lojas virtuais completas",
    description:
      "Loja virtual completa para vender online com segurança e praticidade, com planos mensais que cuidam de tudo para você.",
    image: "/images/imagem2.jpg",
    startingAt: "R$ 3.999,90",
    deliveryTime: "30–45 dias",
    features: ["Loja Completa", "Planos Mensais", "Suporte Técnico"],
    serviceTypes: [
      {
        name: "E-commerce Completo",
        description: "Uma loja virtual completa para vender online com segurança e praticidade.",
        price: "R$ 3.999,90",
        priceNote: "Custo de desenvolvimento + planos com mensalidades",
        features: [
          "Catálogo de produtos com fotos e descrições",
          "Carrinho de compras e integração com meios de pagamento (Pix, cartão, boleto)",
          "Sistema de pedidos e controle de estoque",
          "Responsivo para todas as telas",
        ],
      },
    ],
    plans: [
      {
        name: "Start",
        fullName: "Plano Básico - Start",
        price: "R$ 129,90",
        description: "Para quem está começando a vender online e quer uma estrutura simples.",
        features: [
          "Hospedagem e banco de dados",
          "Manutenção técnica básica",
          "Correção de bugs",
          "Certificado SSL",
          "Até 30 produtos cadastrados",
          "Suporte via chamado",
        ],
      },
      {
        name: "Pro",
        fullName: "Plano Intermediário - Pro",
        price: "R$ 189,90",
        description: "Para quem já tem um volume médio de vendas e quer mais recursos.",
        featured: true,
        features: [
          "Cadastro ilimitado de produtos",
          "Integração com mais meios de pagamento",
          "Relatórios de vendas básicos",
          "3 contas de e-mail profissional",
          "Suporte via WhatsApp em horário comercial",
          "Atualizações trimestrais no sistema",
        ],
      },
      {
        name: "Master",
        fullName: "Plano Avançado - Master",
        price: "R$ 249,90",
        description: "Para quem quer uma loja completa, automatizada e com suporte premium.",
        features: [
          "Automação de marketing",
          "Relatórios avançados de vendas e comportamento",
          "Suporte técnico prioritário em até 24h",
          "Personalização visual da loja a cada 6 meses",
          "Até 10 contas de e-mail profissional",
          "Backups automáticos diários",
        ],
      },
    ],
    technologies: ["React", "Docker", "Node.js", "PostgreSQL", "JWT", "TypeScript", "Fastify", "Prisma", "AWS", "Java", "Spring Boot", "Python"],
  },
  {
    id: "sistemas",
    title: "Sistemas sob medida",
    kicker: "Software & Aplicativos",
    description:
      "Sistemas pensados para a rotina do seu negócio: clínicas, delivery, controle de estoque, gestão empresarial e muito mais.",
    image: "/images/imagem1.jpg",
    startingAt: "Sob consulta",
    deliveryTime: "Sob consulta",
    features: ["Sob Medida", "Sistemas Clínicos", "Apps Delivery"],
    serviceTypes: [
      {
        name: "Sistemas Personalizados e Aplicativos",
        description: "Desenvolvemos sistemas sob medida para o seu negócio, como:",
        price: "Valor sob consulta",
        priceNote: "Conte sua ideia! Vamos analisar e enviar um orçamento personalizado.",
        features: [
          "Sistemas para clínicas com agendamento online, prontuário eletrônico, controle de pacientes e pagamentos",
          "Aplicativos para delivery, controle de estoque, gestão empresarial e muito mais",
        ],
      },
    ],
    technologies: ["Metodologias Ágeis", "LGPD", "Python", "Django", "React Native", "AWS", "Docker"],
  },
]

export const complementaryServices = [
  {
    name: "Tráfego Pago",
    description:
      "Campanhas no Google Ads, Facebook Ads e Instagram com estratégias segmentadas para atrair clientes e gerar vendas.",
  },
  {
    name: "SEO",
    description:
      "Otimizamos sites já existentes com técnicas modernas de SEO para melhorar o ranqueamento no Google.",
  },
  {
    name: "Design Gráfico",
    description:
      "Identidade visual, logotipos, posts para redes sociais, banners e materiais alinhados ao seu negócio.",
  },
  {
    name: "Manutenção de Sites",
    description:
      "Correções, novos recursos ou redesigns completos para sites que já estão no ar.",
  },
  {
    name: "Treinamentos",
    description:
      "Capacitações em metodologias ágeis (Scrum, Kanban, Lean) e ferramentas como Trello, Jira e Notion.",
  },
]

export const projects = [
  { image: "/images/pvt-consultoria.png", name: "PVT Consultoria", details: "Plataforma de consultoria empresarial com dashboard interativo", category: "Sistemas" },
  { image: "/images/wg-estacionamento.png", name: "WG Estacionamento", details: "Sistema completo para gerenciamento de estacionamento", category: "Sistemas" },
  { image: "/images/bellacor-tintas.png", name: "Bellacor Tintas", details: "E-commerce de tintas e materiais de construção", category: "E-commerce" },
  { image: "/images/kjrvagas.png", name: "ADSA - Vagas", details: "Sistema de gestão de vagas e candidatos", category: "Sistemas" },
  { image: "/images/informais.png", name: "Infor-Mais", details: "Landing page com tráfego pago integrado", category: "Sites" },
  { image: "/images/love-pastel.png", name: "Pastelaria Maza", details: "Sistema de comandas para restaurante", category: "Sistemas" },
  { image: "/images/bt-refinish.png", name: "BT Refinish", details: "Site institucional para empresa de acabamentos", category: "Sites" },
  { image: "/images/fernandoCar.png", name: "FernandoCar", details: "Sistema de ponto eletrônico", category: "Sistemas" },
  { image: "/images/adsa-maracana.png", name: "ADSA Cond. Maracanã", details: "Sistema de gestão condominial", category: "Sistemas" },
  { image: "/images/maracana-fc.png", name: "Maracanã Futebol Clube", details: "Site oficial do clube de futebol", category: "Sites" },
]

export const testimonials = [
  {
    company: "Pastelaria Maza",
    logo: "/images/logoMaza.png",
    project: "Sistema de comandas",
    feedback:
      "Sistema maravilhoso. Fiz o pedido para um sistema de Gerar Comandas para meu restaurante. Me entregaram além do que eu imaginava, tanto da parte visual do aplicativo como da usabilidade do aplicativo.",
    rating: 5,
  },
  {
    company: "Informais",
    logo: "/images/informais_1.png",
    project: "Landing page + tráfego pago",
    feedback:
      "Entrei em contato através de indicação, e fechamos para a criação de uma landing page e tráfego pago. Consegui atingir mais clientes na região através deles.",
    rating: 5,
  },
  {
    company: "FernandoCar",
    logo: "/images/logoprov.png",
    project: "Ponto eletrônico",
    feedback:
      "Precisava de um sistema de ponto eletrônico, foi me entregue em um tempo muito rápido, sem contar que a funcionalidade do sistema é fácil para os funcionários e para o departamento que toma conta de visualizar as marcações.",
    rating: 5,
  },
  {
    company: "BellaCor",
    logo: "/images/bella-cor-logo.png",
    project: "Melhorias e manutenção do site",
    feedback:
      "Nosso site tinha algumas alterações e melhorias para serem feitas, e com a KJR as melhorias foram entregues no prazo e com uma qualidade excepcional. Com isso temos parceria com eles para cuidar do nosso site.",
    rating: 5,
  },
]

export const techLogos = [
  "html5", "css", "javascript", "typescript", "react", "nodejs", "docker", "mongodb", "mysql",
  "postgresql", "python", "django", "aws", "redis", "scrum", "dotnet", "googleads", "meta",
  "github", "gitlab", "linux", "redhat", "fastify", "vitest", "flask", "prisma",
].map((name) => ({ name, src: `/images/carrosselNew/${name}.svg` }))
